import * as yup from 'yup';

const validationFields = {
  email: yup
    .string()
    .email('validations.administrators.loanOfficer.email.invalid')
    .required('validations.administrators.loanOfficer.email.required')
    .max(50, 'validations.administrators.loanOfficer.email.maxLength'),
  nmls: yup.string().required('validations.administrators.loanOfficer.nmls.required'),
};

export default yup.object().shape({ ...validationFields });



// WEBPACK FOOTER //
// ./src/forms/administrator/loanOfficerForm.js